// @flow
import { call, put, takeEvery } from 'redux-saga/effects';
import { tripica } from '../../api';
import HandleErrorService from '../../lib/handleError';
import { setLoading } from '../LoadingStatus';
import { fetchAvailableVouchersSuccess } from './actions';

export function* fetchAvailableVouchers(): Generator<*, *, *> {
  yield put(setLoading('refreshAvailableVouchers', true));
  try {
    const vouchers = yield call([tripica.api, 'fetchAvailableVouchers']);
    yield put(fetchAvailableVouchersSuccess(vouchers));
  } catch (e) {
    HandleErrorService.showToastError(e);
  } finally {
    yield put(setLoading('refreshAvailableVouchers', false));
  }
}

export default function*(): Generator<*, *, *> {
  yield* [takeEvery('FETCH_AVAILABLE_VOUCHERS', fetchAvailableVouchers)];
}
